import EditEmployeeRate from './EditEmployeeRate';

export default EditEmployeeRate;